import { render, staticRenderFns } from "./QoForm.vue?vue&type=template&id=6f4edb12&"
import script from "./QoForm.vue?vue&type=script&lang=js&"
export * from "./QoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports